const NOT_FUTURE_NAMES = new Set([
  'lossdate',
  'policyeffectivedate',
  'reporteddate',
]);

const MUST_BE_AFTER = {
  reporteddate:         'lossdate',
  policyexpirationdate: 'policyeffectivedate',
};

function isDateType(t) {
  return t === 'date'
      || t === 'datetime'
      || t === 'datewithusertimezone'
      || t === 'datetimetimezone';
}

export function datePolicyProvider(config, allConfigs) {
  if (!isDateType(config.fieldType)) return null;

  const name = String(config.name || '').toLowerCase();
  if (!name) return null;

  const validation = [];

  if (NOT_FUTURE_NAMES.has(name)) {
    validation.push({ rule: 'maxDate', value: 'today' });
  }

  const afterName = MUST_BE_AFTER[name];
  if (afterName) {
    const other = allConfigs.find(c => String(c.name || '').toLowerCase() === afterName);
    if (other) {
      validation.push({ rule: 'minDateField', value: other.fieldKey });
    }
  }

  return validation.length ? { validation } : null;
}